<template>
   <div>
    <v-select
      class="mt-6 mb-n12 hidden-md-and-up"
      v-model="select"
      :items="types"
      :hint="`${select.subtitle}`"
      item-text="title"
      persistent-hint
      outlined
      single-line
      return-object
      item-color="secondary lighten-1"
      color="secondary lighten-1"
    >
      <template v-slot:item="{ item }">
        <v-list two-line>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon color="secondary lighten-1">
                {{ item.icon }}
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.subtitle }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-select>
    <v-tabs
      class="mt-8"
      v-model="tab"
      :vertical="this.$vuetify.breakpoint.name === 'xs' ? false: true"
      color="secondary-ligthen-1"
      background-color="transparent">
        <v-tab
          class="white--text hidden-sm-and-down"
          active-class="primary darken-1 secondary--text text--lighten-1"
          v-for="(typeItem, typeIndex) in types" :key="typeIndex"
          style="height: 90px; justify-content: start!important;">
            <v-icon class="mr-2" :color="tab !== typeIndex ? 'white': ''" size="34">
              {{typeItem.icon}}
            </v-icon>
            <div class="py-3" style="display: flex; align-items: start; flex-direction: column">
              <h2 style="font-weight: bold; font-size: 16px; line-height: 20px;">
                {{typeItem.title}}
              </h2>
              <h3 class="white--text" style="font-family: Roboto; font-style: normal; font-weight: 300; font-size: 12px; line-height: 16px;">
                {{typeItem.subtitle}}
              </h3>
            </div>
        </v-tab>

        <v-tabs-items v-model="tab">
          <v-tab-item class="elevation-0" v-for="(typeItem, typeIndex) in types" :key="typeIndex">
              <rain-estimation-historical-data-form
                :type="typeItem.value"
                :basins="basins"
                :searchResult="searchResult"
                :formInformationMessage="formInformationMessage"
                @searchBasinData="searchBasinData($event)"></rain-estimation-historical-data-form>
          </v-tab-item>
        </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import RainEstimationHistoricalDataForm from './RainEstimationHistoricalDataForm.vue';

export default {
  components: {RainEstimationHistoricalDataForm },
  name: "RainEstimationHistoricalDataType",
  props: {
      types: {
          type: Array,
          required: true,
      },
      basins: {
        type: Array,
        required: true,
      },
      searchResult: {
        type: Object,
      },
      formInformationMessage: {
        type: String,
        required: false
      },
      dataType: {
        type: String,
        required: true,
      },
  },
  data:() => ({
    select: '',
    tab: undefined,
  }),

  created() {
    this.select = this.types[0];
  },


  watch: {
      select(value){
          if(value){
              for(let index in this.types){
                  if(this.types[index].value === value.value){
                      this.tab = Number(index);
                  }
              }
          }
      },
      tab(value){
          if(value !== undefined){
              const dataType = this.types[value];
              this.changeDataType(dataType);
          }
      }
  },

  methods: {
      changeDataType(dataType){
          this.$emit("changeDataType", dataType);
      },
      searchBasinData(basinFormParams){
        const dataType = this.types[this.tab];
        this.$emit("searchBasinData", {...basinFormParams, dataType});
      }

  }
};
</script>

<style>
.v-tab {
  text-transform: none;
}
.v-tabs-slider{
 color: var(--v-secondary-lighten1) !important;
}
</style>
